@import (reference) '../../../../../../constants/spacing.module.less';

.section {
  border: 1px solid var(--grey-300);
  border-radius: @space-4;
}

.header-border {
  border-bottom-color: var(--grey-300);
}

.caret {
  width: 20px;
}

.caret svg {
  width: 10px;
  height: 10px;
}

.section-header {
  justify-content: space-between;
  width: 100%;
  padding: @space-8 @space-4;
}

.products-table {
  max-height: 200px;
  overflow-y: auto;
}

.products-table-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: @space-8;
  padding: @space-4 @space-12;
}

.sku-button {
  text-align: left;
  justify-content: flex-start;
}
